import allTranslations from "./translation.json";
import navigationTrans from "./navigations.json";
import alertMessage from "./alertMessage.json";
import coins from "./coins.json";
import LoginRegister from "./LoginRegister.json";
// import loginWithMobileNumber from "./loginWithMobileNumber.json";
import setting from "./setting.json";
import invitation from "./invitation.json";
import transactionHistory from "./transactionHistory.json";
import Market from "./market.json";
import trade from "./trade.json";
import collateral from "./collateral.json";
import portfolio from "./portfolio.json";
import dashboard from "./dashboard.json";
import KYC from "./KYC.json";
import balance from "./balance.json";
import withdraw from "./withdraw.json"

const En = {
  ...allTranslations,
  ...navigationTrans,
  ...alertMessage,
  ...coins,
  ...LoginRegister,
  // ...loginWithMobileNumber,
  ...setting,
  ...invitation,
  ...transactionHistory,
  ...Market,
  ...trade,
  ...collateral,
  ...portfolio,
  ...dashboard,
  ...KYC,
  ...balance,
  ...withdraw,
};

export default En;
